import { Component } from '@angular/core';
import { soundpostReportOutputProductGLActivitySummaryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Report Output Product GL Activity Summaries') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreportoutputproductglactivitysummary-form',
    templateUrl: './soundpostreportoutputproductglactivitysummary.form.component.html'
})
export class soundpostReportOutputProductGLActivitySummaryFormComponent extends BaseFormComponent {
    public record!: soundpostReportOutputProductGLActivitySummaryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

